var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-upload",
        {
          ref: "uploadFile_" + _vm.type,
          attrs: {
            action: "#",
            "auto-upload": false,
            limit: _vm.limitNum,
            accept: ".jpg,.jpeg,.png,.pdf",
            "on-preview": _vm.handlePreview.bind(this, _vm.type),
            "on-change": _vm.handleFile.bind(this, _vm.type),
            "on-remove": _vm.handleRemove.bind(this, _vm.type),
            "before-remove": _vm.handleBeforeRemove.bind(this, _vm.type),
            "on-exceed": _vm.handleFileExceed.bind(this, _vm.type),
            "file-list": _vm.fileList[_vm.type],
            disabled: _vm.disabled,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.uploading[_vm.type],
                  expression: "!uploading[type]",
                },
              ],
              staticClass: "upload-container full-style",
            },
            [
              _c("div", { staticClass: "upload-inner" }, [
                _c("div", { staticClass: "icon-add" }, [_vm._v("+")]),
                _c("div", { staticClass: "upload-main-text" }, [
                  _vm._v(_vm._s(_vm.$t("kyc.upload_document"))),
                ]),
                _c("div", { staticClass: "upload-sub-text" }, [
                  _vm._v(_vm._s(_vm.$t("kyc.upload_tip"))),
                ]),
                _c("div", { staticClass: "upload-tip" }, [
                  _vm._v(_vm._s(_vm.$t("kyc.upload_format"))),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _c("Progress", { attrs: { progress: _vm.uploadingProgress[_vm.type] } }),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogImageVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogImageVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }